import type {SenseAction} from 'src/action-creators/types';
import {BATCH_ACTIONS, BatchAction} from 'src/action-creators/batch';


export type BatchReducer<S, A> = (arg1: S, arg2: A | BatchAction) => S;

export default function enableBatching<S, A extends SenseAction>(
  reducer: (arg1: S, arg2: A) => S,
): BatchReducer<S, A> {
  // @ts-expect-error - TS7023 - 'batchingReducer' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions.
  return function batchingReducer(
    state: S,
    action: A | SenseAction | BatchAction,
  ) {
    if (action.type === BATCH_ACTIONS) {
      return action.payload.reduce(batchingReducer, state);
    }
    // @ts-expect-error - TS2345 - Argument of type 'SenseAction | A' is not assignable to parameter of type 'A'.
    return reducer(state, action);
  };
}
